import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import WhatsappCampaignsAPI from '../../api/whatsappCampaigns';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getWhatsappCampaigns(_state) {
    return _state.records.sort((a, b) => b.id - a.id);
  },
  getWhatsappCampaignById: _state => id => {
    return _state.records.find(record => record.id === Number(id));
  },
  getActiveCampaigns(_state) {
    return _state.records.filter(record => record.enabled);
  },
};

export const actions = {
  get: async function getWhatsappCampaigns({ commit }) {
    commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isFetching: true });
    try {
      const response = await WhatsappCampaignsAPI.get();
      commit(types.SET_WHATSAPP_CAMPAIGNS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isFetching: false });
    }
  },

  // Silent get - for background polling without UI loading state
  getSilent: async function getWhatsappCampaignsSilent({ commit }) {
    try {
      const response = await WhatsappCampaignsAPI.get();
      commit(types.SET_WHATSAPP_CAMPAIGNS, response.data);
    } catch (error) {
      // Ignore error silently
    }
  },

  create: async function createWhatsappCampaign({ commit }, campaignObj) {
    commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isCreating: true });
    try {
      const response = await WhatsappCampaignsAPI.create(campaignObj);
      commit(types.ADD_WHATSAPP_CAMPAIGN, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isUpdating: true });
    try {
      const response = await WhatsappCampaignsAPI.update(id, updateObj);
      commit(types.EDIT_WHATSAPP_CAMPAIGN, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isDeleting: true });
    try {
      await WhatsappCampaignsAPI.delete(id);
      commit(types.DELETE_WHATSAPP_CAMPAIGN, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isDeleting: false });
    }
  },

  toggle: async ({ commit }, id) => {
    commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isUpdating: true });
    try {
      const response = await WhatsappCampaignsAPI.toggle(id);
      commit(types.EDIT_WHATSAPP_CAMPAIGN, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isUpdating: false });
    }
  },

  restart: async ({ commit }, id) => {
    commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isUpdating: true });
    try {
      const response = await WhatsappCampaignsAPI.restart(id);
      commit(types.EDIT_WHATSAPP_CAMPAIGN, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isUpdating: false });
    }
  },

  runNow: async ({ commit }, id) => {
    commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isUpdating: true });
    try {
      const response = await WhatsappCampaignsAPI.runNow(id);
      commit(types.EDIT_WHATSAPP_CAMPAIGN, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_WHATSAPP_CAMPAIGN_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_WHATSAPP_CAMPAIGN_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.ADD_WHATSAPP_CAMPAIGN]: MutationHelpers.create,
  [types.SET_WHATSAPP_CAMPAIGNS]: MutationHelpers.set,
  [types.EDIT_WHATSAPP_CAMPAIGN]: MutationHelpers.update,
  [types.DELETE_WHATSAPP_CAMPAIGN]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
